/**
 * Local-storage helpers for the multitenant client. The session
 * itself lives in an HttpOnly cookie set by the Worker — JS can't
 * read it, which is the point. The active property id is a UI
 * preference that we cache locally so a refresh keeps the same
 * property view.
 */

const ACTIVE_PROPERTY_KEY = 'houseops:active-property';

export function getActivePropertyId(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(ACTIVE_PROPERTY_KEY);
}

export function setActivePropertyId(value: string | null): void {
  if (typeof window === 'undefined') return;
  if (value === null) window.localStorage.removeItem(ACTIVE_PROPERTY_KEY);
  else window.localStorage.setItem(ACTIVE_PROPERTY_KEY, value);
}
